export const britecoreVersionRequestMiddleware = {
  // All JSON:API calls should append BriteCore-Version request header
  // Currently the header value is a mocked date value.
  name: 'add-britecore-version-header-to-request',
  req: (payload) => {
    payload.req.headers['BriteCore-Version'] = '2020-07-16'
    return payload
  }
}

export const errorMiddleware = {
  name: 'britecore-error-middleware',
  error: (payload) => {
    // The default error middleware processes the payload and return the following data structure
    //
    //   {<field-name>: {title: '...', detail: '...'}, ... }
    //   This is not ideal as it drops useful keys such as code, source, and status.
    //
    // This replacement middleware returns an object with errors key, accompanied by a list of objects
    // as value, where it contains code, source, status, and detail for each error.
    //
    //   {errors: [ {code: '...', source: '...', status: 200, detail: '...'}, ... ]}
    const {response: {data: {errors} = {}} = {}} = payload
    return {errors: errors}
  }
}
